
    import '/mnt/src/components/Button/index.md?watch=parent';
    export const demoIndex = {
  ids: ["button-demo-demo","button-demo-group-demo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Button/index.md?type=demo')
};